import { Employee } from '../interfaces/Employee';

/**
 * Суммы в токенах. В базе они `numeric(8, 2)`: до двух знаков после запятой и
 * меньше миллиона — та же проверка стоит на бэке.
 *
 * Считаются в копейках целыми числами, а не через `parseInt`: тот отбрасывал
 * дробную часть, и оклад 1000.5 показывался и суммировался как 1000.
 */
export const AMOUNT_PATTERN = /^\d{1,6}(\.\d{1,2})?$/;

/** '1000.50' → 100050. Пустое и `null` — ноль: так база хранит «нет премии». */
export const toCents = (value: string | number | null | undefined): number =>
  Math.round(Number(value ?? 0) * 100);

/** 100050 → '1000.5' — без лишних нулей, в том виде, что уходит на бэк. */
export const centsToAmount = (cents: number): string => String(cents / 100);

/** Сколько получит сотрудник в ближайшую выплату, в копейках. */
export const payoutCents = (employee: Employee): number =>
  toCents(employee.salary) +
  toCents(employee.bonus) -
  toCents(employee.penalty);

export const totalPayoutCents = (employees: Employee[]): number =>
  employees.reduce((sum, employee) => sum + payoutCents(employee), 0);

const formatter = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

/** Для показа: '1 000,5'. */
export const formatTokens = (
  value: string | number | null | undefined,
): string => formatter.format(Number(value ?? 0));

export const formatCents = (cents: number): string =>
  formatter.format(cents / 100);

/** Значение из базы ('1000.50') → поле ввода ('1000.5'). */
export const toInputAmount = (value: string | null | undefined): string =>
  centsToAmount(toCents(value));
